import $ from 'jquery';
import '@selectize/selectize';

// Function for normalizing string and search for filtering
const normalizeForFiltering = (string) => {
  return string.normalize("NFD")
  .replaceAll(/[\u0300-\u036F]/g, '')
  .replaceAll(/[\s'-]/g, '')
  .toLowerCase();
};

$(function () {
  // Basic selectize
  $('.selectize').selectize({
    closeAfterSelect: true,
    plugins: ['remove_button'],
  });

  // Autocomplete selectize
  const autocomplete = $('.selectize-autocomplete');
  autocomplete.selectize({
    plugins: ['remove_button'],
    labelField: 'label',
    valueField: 'value',
    searchField: ['label'],
    closeAfterSelect: true,
    normalize: true,
    onType: closeIfEmpty, //if the user deletes all characters, close the modal
    onDropdownOpen: closeIfEmpty, //if the user generates a focus and there is no input, close the modal
    optionGroupRegister: function (optgroup) {
      const capitalised = optgroup.charAt(0).toUpperCase() + optgroup.slice(1);
      const group = {
        label: capitalised,
      };

      group[this.settings.optgroupValueField] = optgroup;

      return group;
    },
    onItemAdd: function () {
      //focus back on the actual input
      $('#region-selectized').trigger("focus");
    },
    optgroupField: 'optgroup',
    score: function (search) {
      // Hide selections when search is too short (to avoid merged results)
      if (search.length < 2) {
        return () => 0;
      }
      // Override search value if numeric. Example : search "(33"
      const isNumeric = !Number.isNaN(Number.parseFloat(search));
      if (isNumeric) {
        search = '(' + search;
      }

      // Search value in labels
      return function (item) {
        return normalizeForFiltering(item.label).includes(normalizeForFiltering(search)) ? 1 : 0;
      };
    },
    load: function (query, callback) {
      if (query.length < 2) {
        return callback();
      }

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        dataType: 'json',
        data: {
          'action': 'autocomplete_region',
          'q': query,
        },
        success: (response) => {
          // Do not delete existing options
          for (const item of response) {
            this.addOption(item);
          }

          // Reactivate previous options
          this.refreshOptions(false);

          callback(response);
        },
        error: () => {
          callback();
        },
      });
    },
  });

  $(document).on('click', '#reset-filters', () => {
    window.location.search = '';
  });
});

$(() => {
  $(document).on('change', '#sort_by', () => {
    const option = $('#sort_by option:selected').val();
    const urlParameters = new URLSearchParams(window.location.search);
    urlParameters.set('sort_by', option);
    window.location.search = urlParameters;
  });
});

function closeIfEmpty() {
  if (this.$control_input.val().length === 0) {
    this.close();
  }
}
